import React from "react";
import TERMS_HTML from "./termsHtml";
import "./PrivacyPolicy.css"; // reuse the same styling

export default function TermsAndConditions() {
  return (
    <div className="privacy-page">
      <div className="privacy-wrapper">
        <div
          className="privacy-container"
          dangerouslySetInnerHTML={{ __html: TERMS_HTML }}
        />
      </div>
    </div>
  );
}

